import { History } from 'history';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import en from '../../../lang/en-us';
import { LoadDots } from '../../../lib/Button';
import { CustomToolTip } from '../../../lib/DataTable';
import { getMasterData, getMasterFunds } from '../../../redux-store/actions/newPurchase';
import { RootStateType } from '../../../redux-store/reducers';
import { ResponseStatus } from '../../../redux-store/types/newPurchase';
import { IsAllow } from '../../../redux-store/types/portfolio';
import { FAQ_URL, isMobileDevice } from '../../../utils/constants';
import HomePageCard from '../../home/card';
import { isMobile } from '../../quick-links/faq';
import RouteWrapper from '../routes';
import { EmandateRoutes } from './emandate/routes';
import { EMandatePaths } from './emandate/types';
import { ExplorePaths } from './ExploreMFs/types';
import { CommercialRootPath, CommercialRoutes } from './routeConfig';
import { SipPaths } from './Sip/types';
import { STPPaths } from './STP/types';
import { SwitchPaths } from './Switch/types';
import { SWPPaths } from './SWP/routes';
const { dbCommercial, common } = en;

type CT_ACTIONS = {
    actionName: string;
    image1: string;
    image2: string;
    onClickAction: Function;
    spanText?: string;
    comingSoon?: boolean;
    loading?: boolean;
    disabled?: boolean;
    toolTipText?: string;
};

type FaqLinkProps = {
    history?: History;
    section: string;
};

type ActionHeaderProps = {
    header: string;
    subHeader?: string;
};

export const FaqLink = ({ section }: FaqLinkProps) => {
    const _history = useHistory();
    return (
        <h5 className="refer-faq-link" style={{ marginTop: 10 }}>
            {common.referFAQ}
            <a
                className="link-active"
                onClick={() => {
                    if (isMobileDevice() || isMobile(window.navigator.userAgent)) {
                        _history.push(FAQ_URL, { section });
                    } else {
                        window.open(
                            `${window.location.origin}/links/faq?section=${section}`,
                            '_blank',
                        );
                        // obj.location. = section;
                    }
                }}
            >
                {common.FAQ}
            </a>
        </h5>
    );
};

export const ActionHeader = ({ header = '', subHeader }: ActionHeaderProps) => {
    const history = useHistory();
    return (
        <h2 className="heading">
            <a onClick={() => history.goBack()}>
                <img src="/images/left-arrow-black.svg" alt="icon" />
            </a>
            {header}
            {subHeader && <span>{subHeader}</span>}
        </h2>
    );
};

export function CommercialActions(params: any) {
    const { otmRegistrationFlag } = useSelector(({ authReducer }: RootStateType) => ({
        otmRegistrationFlag: authReducer?.otmRegistration,
    }));

    const actions: CT_ACTIONS[] = [
        {
            actionName: dbCommercial.ctLinks.newPurchase,
            image1: '/images/new-purchase.svg',
            image2: '/images/new-purchase-white.svg',
            onClickAction: () =>
                params.history.push(`/portal/commercial${ExplorePaths.NewPurchase}`),
        },
        {
            actionName: dbCommercial.ctLinks.additionalPurchase,
            image1: '/images/additional-purchase.svg',
            image2: '/images/additional-purchase-white.svg',
            onClickAction: () => params.history.push('/portal/commercial/additional-purchase'),
        },
        // {
        //     actionName: dbCommercial.ctLinks.sip,
        //     image1: '/images/sip.svg',
        //     image2: '/images/sip-white.svg',
        //     onClickAction: () => params.history.push(`/portal/commercial${SipPaths.Sip}`),
        // },
        {
            actionName: dbCommercial.ctLinks.redemption,
            image1: '/images/redemption.svg',
            image2: '/images/redemption-white.svg',
            onClickAction: () => params.history.push('/portal/commercial/redemption'),
            comingSoon: false,
        },
        {
            actionName: dbCommercial.ctLinks.switch,
            image1: '/images/switch.svg',
            image2: '/images/switch-white.svg',
            onClickAction: () => params.history.push(`${CommercialRootPath}${SwitchPaths.Switch}`),
        },
        {
            actionName: dbCommercial.ctLinks.eMandate,
            image1: '/images/e-mandate.svg',
            image2: '/images/e-mandate-white.svg',
            onClickAction: () =>
                params.history.push(`${CommercialRootPath}${EMandatePaths.OtmDetails}`),
            comingSoon: otmRegistrationFlag !== IsAllow.YES,
        },
        {
            actionName: dbCommercial.ctLinks.stp,
            image1: '/images/stp.svg',
            image2: '/images/stp-white.svg',
            onClickAction: () => params.history.push(`${CommercialRootPath}${STPPaths.STP}`),
            // comingSoon: true,
        },
        {
            actionName: dbCommercial.ctLinks.swp,
            image1: '/images/swp.svg',
            image2: '/images/swp-white.svg',
            onClickAction: () => params.history.push(`${CommercialRootPath}${SWPPaths.SWP}`),
        },
        {
            actionName: dbCommercial.ctLinks.sipPause,
            image1: '/images/sip-pause.svg',
            image2: '/images/sip-pause-white.svg',
            onClickAction: () => params.history.push(`${CommercialRootPath}${SipPaths.Sip}`),
            // comingSoon: true,
        },
    ];
    const [searchString, setSearchString] = useState<string>('');

    const _handleCTSearch = () => {
        if (!!searchString) {
            return actions.filter((_ele: CT_ACTIONS) =>
                _ele.actionName.toLowerCase().includes(searchString.toLowerCase()),
            );
        }
        return actions;
    };
    return (
        <div className="curved-bg">
            <div className="make-nct make-ct">
                <HomePageCard className="db-banner">
                    <>
                        <img
                            className="db-banner-character"
                            src="/images/ct-character.png"
                            alt="icon"
                        />
                        <h3>
                            {dbCommercial.heading}
                            <b>{dbCommercial.headingBold}</b>
                        </h3>
                        <p>{dbCommercial.subheading}</p>
                    </>
                </HomePageCard>
                <div className="make-nct-bottom">
                    <div className="box-cards-links db-nct-list">
                        {_handleCTSearch().map((_ele: CT_ACTIONS, index: number) => (
                            <div className="box-cards-links-info" key={index}>
                                <CustomToolTip arrow title={_ele.toolTipText || ''}>
                                    <a
                                        onClick={() =>
                                            !_ele.comingSoon &&
                                            !_ele.disabled &&
                                            _ele.onClickAction()
                                        }
                                    >
                                        <div className="nct-list-images">
                                            <img
                                                className="nct-box-inactive"
                                                src={_ele.image1}
                                                alt="icon"
                                            />
                                            <img
                                                className="nct-box-active"
                                                src={_ele.image2}
                                                alt="icon"
                                            />
                                        </div>
                                        {_ele.comingSoon && (
                                            <img
                                                className="nct-coming-soon"
                                                src="/images/coming-soon.svg"
                                                alt="icon"
                                            />
                                        )}
                                        <h4>
                                            {_ele.actionName}
                                            {_ele.spanText && <span>{_ele.spanText}</span>}
                                        </h4>
                                        {_ele.loading && (
                                            <div className="nct-list-loader">
                                                {_ele.loading && <LoadDots />}
                                            </div>
                                        )}
                                    </a>
                                </CustomToolTip>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default (props: any) => {
    const dispatch = useDispatch();
    const { exploreSchemeDataStatus, masterDataApiStatus } = useSelector(
        ({ newPurchase }: RootStateType) => ({
            ...newPurchase,
        }),
    );
    useEffect(() => {
        dispatch(getMasterFunds());
        dispatch(getMasterData());
    }, []);
    return (
        <RouteWrapper
            routes={CommercialRoutes}
            matchPath={props.match.path}
            initPath={'/actions'}
            {...props}
        />
    );
};
